import { BrollEffects, CaptionStyleId, FontFamily, FontWeight } from '../types';

export const SUBTITLE = [];

export const DEFAULT_METADATA = {
  id: '123',
  component: 'MyComp',
  durationInSec: 200,
  videoWidth: 1920,
  videoHeight: 1080,
  videoFps: 30,
  durationInFrames: 200,
  thumbnail: '',
};

export const BROLL_EFFECTS = [
  {
    id: BrollEffects.NoAnimation,
    icon: 'TransitionIcon.svg',
    label: 'No Animation',
    blendStyle: 'screen',
    type: 'style',
    path: '',
  },
  {
    id: BrollEffects.ZoomIn,
    icon: 'zoom-in.svg',
    label: 'Zoom In',
    blendStyle: 'screen',
    type: 'style',
    path: '',
  },
  {
    id: BrollEffects.ZoomOut,
    icon: 'zoom-contain.svg',
    label: 'Zoom Out',
    blendStyle: 'screen',
    type: 'style',
    path: '',
  },
  {
    id: BrollEffects.ZoomFast,
    icon: 'zoom-fast.svg',
    label: 'Zoom Fast',
    blendStyle: 'screen',
    type: 'style',
    path: '',
  },
  {
    id: BrollEffects.ZoomSlow,
    icon: 'zoom-slow.svg',
    label: 'Zoom Slow',
    blendStyle: 'screen',
    type: 'style',
    path: '',
  },
  {
    id: BrollEffects.Comic,
    icon: 'comic.svg',
    label: 'Comic',
    blendStyle: 'screen',
    type: 'video',
  },
  {
    id: BrollEffects.FilmBurn,
    icon: 'film-burn.svg',
    label: 'Film Burn',
    blendStyle: 'lighten',
    type: 'video',
  },
  {
    id: BrollEffects.FilmBurn2,
    icon: 'film-burn.svg',
    label: 'Film Burn 2',
    blendStyle: 'plus-lighter',
    type: 'video',
  },
  {
    id: BrollEffects.FilmBroll,
    icon: 'film-broll.svg',
    label: 'Film Broll',
    blendStyle: 'plus-lighter',
    type: 'video',
  },
  {
    id: BrollEffects.Vintage,
    icon: 'vintage.svg',
    label: 'Vintage',
    blendStyle: 'plus-lighter',
    type: 'video',
  },
  {
    id: BrollEffects.Glitch,
    icon: 'glitch.svg',
    label: 'Glitch',
    blendStyle: 'lighten',
    type: 'video',
  },
];

export const FALLBACK_VIDEO_MESSAGE =
  'Your browser is unable to play the video. Please use Chrome for best experience.';

export const FONT_FAMILY = [
  {
    id: FontFamily.Inconsolata,
    label: 'Inconsolata',
  },
  {
    id: FontFamily.Sora,
    label: 'Sora',
  },
  {
    id: FontFamily.Sofadi,
    label: 'Sofadi One',
  },
  {
    id: FontFamily.Bangers,
    label: 'Bangers',
  },
  {
    id: FontFamily.Montserrat,
    label: 'Montserrat',
  },
];

export const FONT_WEIGHT = [
  {
    id: FontWeight.Weight200,
    label: 'Light',
  },
  {
    id: FontWeight.Weight400,
    label: 'Normal',
  },
  {
    id: FontWeight.Weight900,
    label: 'Bold',
  },
];

export const UPLOADED_PUBLIC_ASSETS_URL_2 = 'https://public-static-dev.txt2create.com/assets/'; // TOOD: move to env

export const FPS = 30;
export const COMP_NAME = "TimelineEditor";
export const DURATION_IN_FRAMES = 30;
export const VIDEO_WIDTH = 1280;
export const VIDEO_HEIGHT = 720;